export default {
  replaceContact(state) {
    state.work.contact = {}
  }
}
